import Vue from 'vue'
import Router from 'vue-router'
import constants from "../constants";
import lodash from "lodash"
import main from "../main"
import { DATA_TOPIC } from '../../config/topic'
import { DATA_HUT } from '../../config/huts'
import mappingStores from '@/assets/json_files/stores.json'

const ComboDetail = () => import('@/components/combo/ComboDetail.vue');
const Register = () => import('@/pages/Register.vue');
const ForgotPassword = () => import('@/pages/ForgotPassword.vue');
const SetNewPassWord = () => import('@/pages/SetNewPassword.vue');
const Profile = () => import('@/pages/Profile.vue');
const AccountInfo = () => import('@/pages/AccountInfo.vue')
const SavedCard = () => import('@/pages/SavedCard.vue')
const HutRewards = () => import('@/pages/HutRewards.vue')
const FreeSide = () => import('@/pages/FreeSide.vue')
const HutRewardsDetail = () => import('@/pages/HutRewardsDetail.vue')
const SliceHistory = () => import('@/pages/SliceHistory.vue')
const EditProfile = () => import('@/pages/EditProfile.vue');
const Ponta = () => import('@/pages/Ponta.vue');
const AddLocation = () => import('@/pages/Location.vue');
const Careers = () => import('@/pages/static/Career.vue');
const News = () => import('@/pages/static/News.vue');
const Aboutus = () => import('@/pages/static/Aboutus.vue');
const History = () => import('@/pages/History.vue');
const Post = () => import('@/pages/static/Post.vue');
const Crs = () => import('@/pages/static/Crs.vue');
const TestLocalization = () => import('@/pages/TestLocalization.vue');
const ResultLocalization = () => import('@/pages/ResultLocalization.vue');
const Confirmation = () => import('@/pages/Confirmation.vue');
const PaymentStatus = () => import('@/pages/PaymentStatus.vue');
const TopicList = () => import('@/pages/TopicList.vue');
const TopicDetail = () => import('@/pages/TopicDetail.vue');
const Campaign = () => import('@/pages/Campaign.vue');
const CouponAttachment = () => import('@/pages/CouponAttachment.vue');
const HomePage = () => import('@/pages/Home.vue');
const HutPage = () => import('@/pages/Hut.vue');
const CategoryPage = () => import('@/pages/Category.vue');
const ContactPage = () => import('@/pages/static/Contact.vue');
const LoginPage = () => import('@/pages/Login.vue');
const CheckoutPage = () => import('@/pages/CheckOut.vue');
const TrackerOrder = () => import('@/pages/TrackerOrder.vue');
const Tracking = () => import('@/pages/Tracking.vue');
const CreditCardPayment = () => import('@/pages/CreditCardPayment.vue');
const GameSlot = () => import('@/pages/GameSlot.vue');
const CouponGame = () => import('@/pages/CouponGame.vue');
const GameReward = () => import('@/pages/GameReward.vue');
const GameSuccess = () => import('@/pages/GameSuccess.vue');
const Rakuten = () => import('@/components/Rakuten.vue');
const PageNotFound = () => import('@/pages/static/errors/404.vue');

Vue.use(Router)

let router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.name == 'home') {
      return { x: 0, y: 0 }
    }
  },
  hashbang: false,
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/huts/:outlet',
      name: 'huts',
      meta: {layout: 'home-landing', meta_title: 'meta.huts'},//home-landing
      component: HutPage,
      beforeEnter: (to, from, next) => {
        const testStore = ['8666']
        let outletId = to.fullPath.split('/')[2]
        let value = ''
        const isExternalChars = outletId.indexOf('-') > - 1;
        if (isExternalChars) {
          outletId = outletId.split('-')[0];
        }
        if (outletId) {
          if (mappingStores.hasOwnProperty(outletId)) {
            value = mappingStores[outletId]
            return next('/huts/' + value)
          } else if (testStore.indexOf(outletId) > -1) {
            return next('/')
          } else if (isExternalChars) {
            return next('/huts/' + outletId)
          } else {
            return next()
          }
        }
      }
    },
    {
      path: '/order/:slug?/:sub?/:nameseo?',//
      name: 'category',
      meta: {layout: 'main', meta_title: 'meta.orders'},
      component: CategoryPage,
      beforeEnter: (to, from, next) => {
        if (to.params.sub === constants.HEADER_MENU.HALF_HALF_HUT_DAY) {
          if (
            Vue.prototype.$session.get('showHutDayHalfAndHalf') === 0 || 
            Vue.prototype.$session.get('orderType') === constants.DELIVERY
          ) {
            return next('/');
          }
          return next();
        }
        next();
      }
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {layout: 'simple', 'key_title': 'header.contact'},
      component: ContactPage
    },
    {
      path: '/login/:method?',
      props: true,
      name: 'login',
      component: LoginPage,
      meta: {layout: 'simple', 'key_title': 'header.login'}
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {layout: 'simple', 'key_title': 'header.register', auth: false, meta_title: 'meta.register'}
    },
    {
      path: '/getmypassword',
      component: ForgotPassword,
      meta: {layout: 'simple', 'key_title': 'header.reset_password', meta_title: 'meta.getmypassword'}
    },
    {
      path: '/setnewpassword/:token',
      component: SetNewPassWord,
      meta: {layout: 'simple', 'key_title': 'header.create_new_password', meta_title: 'meta.forgot_password'}
    },
    {
      path: '/account-info',
      name: 'account_info',
      component: AccountInfo,
      meta: {layout: 'simple', 'key_title': '', 'meta_title': 'meta.profile', auth: true}
    },
    {
      path: '/hut-rewards',
      name: 'hut_rewards',
      component: HutRewards,
      meta: {layout: 'simple', 'key_title': '', 'meta_title': 'meta.profile', auth: true}
    },
    {
      path: '/hut-rewards-detail',
      name: 'hut_rewards_detail',
      component: HutRewardsDetail,
      meta: {layout: 'simple', 'key_title': '', 'meta_title': 'meta.profile'}
    },
    {
      path: '/slice-history',
      name: 'slice_history',
      component: SliceHistory,
      meta: {layout: 'simple', 'key_title': 'slice_history', 'meta_title': 'slice_history', auth: true}
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {layout: 'simple', 'key_title': 'header.my_account_information', 'meta_title':'meta.profile',auth: true}
    },
    {
      path: '/profile/:login?',
      props: true,
      name: 'login_profile',
      component: LoginPage,
      meta: {layout: 'simple', 'key_title': 'header.login'}
    },
    {
      path: '/edit-profile',
      component: EditProfile,
      meta: {layout: 'simple', 'key_title': 'header.update_information', auth: true, 'meta_title':'meta.profile'}
    },
    {
      path: '/ponta-attach',
      name: 'ponta-attach',
      component: Ponta,
      meta: {layout: 'simple', 'key_title': 'header.ponta', auth: true}
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: CheckoutPage,
      meta: {layout: 'simple', 'key_title': 'header.secure_checkout'}
    },
    {
      path: '/credit-payment/:transaction?/:payment_url?',
      name: 'credit-payment',
      component: CreditCardPayment,
      meta: {layout: 'simple', 'key_title': 'header.credit_card'}
    },
    {
      path: '/tracker-order/:uuid?',
      name: 'tracker-order',
      component: TrackerOrder,
      meta: {layout: 'simple'}
    },
    {
      path: '/add-location/:id?',
      name: 'add-location',
      component: AddLocation,
      meta: {layout: 'simple', 'key_title': 'header.location'}
    },
    {
      path: '/payment-status/:transaction?',
      name: 'payment-status',
      component: PaymentStatus,
      meta: {layout: 'simple', 'key_title': 'header.thanks_for_your_payment'},
    },
    {
      path: '/aboutus/:id?',
      name: 'aboutus',
      component: Aboutus,
      meta: {layout: 'simple', 'key_title': 'header.aboutus'}
    },
    {
      path: '/careers/:id?',
      name: 'careers',
      component: Careers,
      meta: {layout: 'simple', 'key_title': 'header.careers'}
    },
    {
      path: '/news/:year?/:month?/:url?',
      name: 'news',
      component: News,
      meta: {layout: 'simple', 'key_title': 'header.news'}
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.policy'},
      props: {type: 'privacy_policy', name: 'policy'}
    },
    {
      path: '/terms',
      name: 'terms',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.terms'},
      props: {type: 'user_member_rules', name: 'terms'}
    },
    {
      path: '/hutrewards',
      name: 'hutrewards',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.hutrewards'},
      props: {type: 'membership_information', name: 'hutrewards'}
    },
    {
      path: '/membership',
      redirect: to => {
        return {
          path: '/hutrewards',
          name: 'hutrewards',
          component: Post,
          meta: {layout: 'simple', 'key_title': 'header.hutrewards'},
          props: {type: 'membership_information', name: 'hutrewards'}
        }
      }
    },
    {
      path: '/indication-based',
      name: 'indication',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.indication'},
      props: {type: 'cmn_commercial_transactions', name: 'commercial-transactions'}
    },
    {
      path: '/nutritional-content',
      name: 'nutritional',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.nutritional'},
      props: {type: 'prd_allergen', name: 'nutritional'}
    },
    {
      path: '/faq',
      name: 'faq',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.faq'},
      props: {type: 'faq', name: 'faq'}
    },
    {
      path: '/crm/coupon/:code?',
      name: 'coupon-attach',
      component: CouponAttachment,
      meta: {layout: 'simple', 'key_title': 'header.coupon_attachment', meta_title: 'meta.coupon_attachment'},
      props: true
    },
    /*{
				path: '/term',
				name: 'term',
				component: Term,
				meta: {layout: 'simple', 'key_title': 'header.terms'}
		},*/
    {
      path: '/crs/:mode?/:sub?',
      name: 'crs',
      component: Crs,
      meta: {layout: 'simple', 'key_title': 'header.crs'}
    },
    {
      path: '/history',
      component: History,
      meta: {layout: 'simple', 'key_title': 'header.history', auth: true}
    },
    {
      path: '/saved-card',
      name: 'saved_card',
      component: SavedCard,
      meta: {layout: 'simple', 'key_title': 'manage_saved_card', auth: true}
    },
    {
      path: '/404',
      name: 'error-404',
      component: PageNotFound,
      meta: {layout: 'error-page'}
    },
    {
      path: '/403',
      name: 'error-403',
      component: {template: '<p>403</p>'}
    },
    {
      path: '/combo-detail/:nameseo/:ssid?/:coupon?',
      name: 'combo-detail',
      component: ComboDetail,
      meta: {layout: 'combo', 'key_title': 'header.combo_detail', meta_title: 'meta.orders'}
    },
    {
      path: '/localization/:zip/:opt?',
      name: 'test-localization',
      component: TestLocalization,
      meta: {
        layout: 'simple',
        'key_title': 'postal_code',
        'sub_title': 'localization.sub_title_result_search',
        'meta_title': 'meta.localization',
        key_params: 'zip'
      }
    },
    {
      path: '/result-localization/:zip/:opt?',
      name: 'result-localization',
      component: ResultLocalization,
      meta: {layout: 'simple', 'key_title': 'localization.title_result_search', key_params: 'zip'}
    },
    {
      path: '/confirmation/:regis',
      name: 'confirmation',
      component: Confirmation,
      meta: {layout: 'simple', 'key_title': '', key_params: 'regis'}
    },
    {
      path: '/light-confirmation/:regis',
      name: 'light-confirmation',
      component: Confirmation,
      meta: {layout: 'simple', 'key_title': '', key_params: 'regis'}
    },
    {
      path: '/',
      name: 'home',
      meta: {layout: 'home', meta_title: "meta.home.title"},
      component: HomePage
    },
    {
      path: '/topic',
      name: 'topic',
      component: TopicList,
      meta: {layout: 'main', 'key_title': 'header.topic', meta_title: 'meta.topic.title'},
    },
    {
      path: '/topic/:name/:code?',
      name: 'topic-detail',
      component: TopicDetail,
      meta: {layout: 'main', 'key_title': 'header.topic'}
    },
    {
      path: '/campaign/:campaignName',
      name: 'campaign',
      component: Campaign,
      meta: {layout: 'Simple', 'key_title': 'header.campaign'}
    },
    {
      path: '/slot',
      name: 'game_slot',
      component: CouponGame,
      meta: {layout: 'null'},
    },
    {
      path: '/old_game', // for redirect old game slot
      name: 'old_game',
      component: GameSlot,
      meta: {layout: 'null'},
    },
    {
      path: '/slot_reward',
      name: 'game_slot_reward',
      component: GameReward,
      meta: {layout: 'null'},
    },
    {
      path: '/slot_success',
      name: 'game_slot_success',
      component: GameSuccess,
      meta: {layout: 'null'},
    },
    {
      path: '/free-side/:uuid',
      name: 'free_side',
      component: FreeSide,
      meta: {layout: 'simple', auth: true}
    },
    {
      path: '*',
      // redirect: {name: 'home'},
      beforeEnter: (to, from, next) => {
        const login = [
          '/pc/cpn_search',
          '/pc/user_password_reset',
          '/pc/user_detail.2',
          '/pc/user_base_modify.3',
          '/pc/user_password_modify.5',
          '/pc/user_mail_modify.7',
          '/user_mail_modify_confirm.8',
          '/user_mail_modify_mail_sent.9',
          '/pc/user_family_modify.13',
          '/pc/user_pontacard_modify.15'
        ]
        const pageNotFound = [
          '/ip/order_list',
          '/pc/order_list',
          '/ip/general/include/cmn_ponta_info.html',
          '/pc/general/include/cmn_ponta_info.html',
          '/ip/general/include/usr_ponta_rules.html',
          '/pc/general/include/usr_ponta_rules.html',
          '/ip/general/include/pizzahut_app.html',
          '/pc/general/include/pizzahut_app.html',
          '/ip/general/include/phcoupon.html',
          '/ip/general/include/prcoupon.html',
          '/ip/general/include/txcoupon.html',
          '/ip/general/include/txcoupon.html#yAtHrhItAAoh5o3K.97',
          '/ip/general/include/vlcoupon.html',
          '/pc/general/include/phcoupon.html',
          '/pc/general/include/prcoupon.html',
          '/pc/general/include/txcoupon.html',
          '/pc/general/include/vlcoupon.html',
          '/pc/general/include/vpcoupon.html',
          '/ip/general/include/ponta.html',
          '/pc/general/include/ponta.html',
          '/ip/general/include/prd_allergen.html',
          '/pc/general/include/prd_allergen.html',
          '/ip/general/include/privacypolicy.html',
          '/ip/general/include/privacypolicy.html#BLciWT4e0JmkfXqz.97',
          '/pc/general/include/privacypolicy.html',
          '/ip/general/include/ph_career.html',
          '/pc/general/include/ph_career.html',
          '/ip/cpn_search',
          '/pc/cpn_search',
          '/ip/excmp_campaign_entry',
          '/ip/excmp_registerd_notice',
          '/ip/excmp/CCF015',
          '/ip/excmp/CCF020',
          '/ip/excmp/CCF022',
          '/ip/excmp/CCF024',
          '/ip/excmp/CCG051',
          '/ip/excmp/CCG447',
          '/ip/excmp/CCG448',
          '/ip/excmp/CCG449',
          '/ip/excmp/CCH575',
          '/ip/excmp/CCN040',
          '/ip/excmp/CCN120',
          '/ip/excmp/CDF038',
          '/ip/excmp/CDF139',
          '/ip/excmp/CDF214',
          '/ip/excmp/CDG045',
          '/ip/excmp/CDG448',
          '/ip/excmp/CDG449',
          '/ip/excmp/CDR515',
          '/ip/excmp/CEG067',
          '/ip/excmp/CER290',
          '/ip/excmp/CFR515',
          '/ip/excmp/CGH223',
          '/ip/excmp/CGH224',
          '/ip/excmp/CGH225',
          '/ip/excmp/CGH226',
          '/ip/excmp/CRH228',
          '/ip/excmp/CRH229',
          '/ip/excmp/CRH230',
          '/ip/excmp/CRH231',
          '/ip/excmp/CRH232',
          '/ip/excmp/CVH208',
          '/ip/excmp/CVH209',
          '/ip/excmp/CVH210',
          '/ip/excmp/CVH211',
          '/ip/excmp/CVH212',
          '/ip/excmp/CVH213',
          '/ip/excmp/CVH214',
          '/ip/excmp/CVH215',
          '/ip/excmp/CVH216',
          '/ip/excmp/CVH217',
          '/ip/excmp/CVH218',
          '/ip/excmp/CVH219',
          '/ip/excmp/CVH220',
          '/ip/excmp/CVH221',
          '/ip/excmp/CVH224',
          '/ip/excmp/CVH225',
          '/pc/excmp_campaign_entry',
          '/pc/excmp_registerd_notice',
          '/pc/excmp/CCF015',
          '/pc/excmp/CCF020',
          '/pc/excmp/CCF022',
          '/pc/excmp/CCF024',
          '/pc/excmp/CCG051',
          '/pc/excmp/CCG447',
          '/pc/excmp/CCG448',
          '/pc/excmp/CCG449',
          '/pc/excmp/CCH575',
          '/pc/excmp/CCN120',
          '/pc/excmp/ccr793',
          '/pc/excmp/CDF038',
          '/pc/excmp/CDF139',
          '/pc/excmp/CDF214',
          '/pc/excmp/CDG045',
          '/pc/excmp/CDG448',
          '/pc/excmp/CDG449',
          '/pc/excmp/CDR515',
          '/pc/excmp/CEG067',
          '/pc/excmp/CFR515',
          '/pc/excmp/CGH223',
          '/pc/excmp/CGH224',
          '/pc/excmp/CGH225',
          '/pc/excmp/CGH226',
          '/pc/excmp/CGH227',
          '/pc/excmp/CRH228',
          '/pc/excmp/CRH229',
          '/pc/excmp/CRH230',
          '/pc/excmp/CRH231',
          '/pc/excmp/CRH232',
          '/pc/excmp/CVH208',
          '/pc/excmp/CVH209',
          '/pc/excmp/CVH210',
          '/pc/excmp/CVH211',
          '/pc/excmp/CVH212',
          '/pc/excmp/CVH213',
          '/pc/excmp/CVH214',
          '/pc/excmp/CVH215',
          '/pc/excmp/CVH216',
          '/pc/excmp/CVH217',
          '/pc/excmp/CVH218',
          '/pc/excmp/CVH219',
          '/pc/excmp/CVH220',
          '/pc/excmp/CVH221',
          '/pc/excmp/CVH222',
          '/pc/excmp/CVH224',
          '/pc/excmp/CVH225',
          '/ip/cpn_search',
          '/pc/cpn_search',
          '/ip/side/W000002350-002',
          '/pc/side/W000002350-002',
          '/ip/side/W000003732-002',
          '/pc/side/W000003732-002',
          '/ip/side/W000003733-002',
          '/pc/side/W000003733-002',
          '/ip/side/W000003734-002',
          '/pc/side/W000003734-002',
          '/ip/choice_pizza.1',
          '/ip/choice_pizza.10',
          '/ip/choice_pizza.11',
          '/ip/choice_pizza.12',
          '/ip/choice_pizza.12.1',
          '/ip/choice_pizza.13',
          '/ip/choice_pizza.14',
          '/ip/choice_pizza.14.1',
          '/ip/choice_pizza.15',
          '/ip/choice_pizza.16',
          '/ip/choice_pizza.17',
          '/ip/choice_pizza.18',
          '/ip/choice_pizza.19',
          '/ip/choice_pizza.2',
          '/ip/choice_pizza.2.1',
          '/ip/choice_pizza.20',
          '/ip/choice_pizza.21',
          '/ip/choice_pizza.22',
          '/ip/choice_pizza.23',
          '/ip/choice_pizza.24',
          '/ip/choice_pizza.25',
          '/ip/choice_pizza.26',
          '/ip/choice_pizza.27',
          '/ip/choice_pizza.28',
          '/ip/choice_pizza.29',
          '/ip/choice_pizza.3',
          '/ip/choice_pizza.30',
          '/ip/choice_pizza.31',
          '/ip/choice_pizza.32',
          '/ip/choice_pizza.33',
          '/ip/choice_pizza.34',
          '/ip/choice_pizza.35',
          '/ip/choice_pizza.36',
          '/ip/choice_pizza.37',
          '/ip/choice_pizza.38',
          '/ip/choice_pizza.39',
          '/ip/choice_pizza.4',
          '/ip/choice_pizza.40',
          '/ip/choice_pizza.42',
          '/ip/choice_pizza.43',
          '/ip/choice_pizza.44',
          '/ip/choice_pizza.45',
          '/ip/choice_pizza.46',
          '/ip/choice_pizza.47',
          '/ip/choice_pizza.48',
          '/ip/choice_pizza.49',
          '/ip/choice_pizza.5',
          '/ip/choice_pizza.51',
          '/ip/choice_pizza.53',
          '/ip/choice_pizza.54',
          '/ip/choice_pizza.55',
          '/ip/choice_pizza.56',
          '/ip/choice_pizza.57',
          '/ip/choice_pizza.59',
          '/ip/choice_pizza.6',
          '/ip/choice_pizza.60',
          '/ip/choice_pizza.61',
          '/ip/choice_pizza.62',
          '/ip/choice_pizza.65',
          '/ip/choice_pizza.66',
          '/ip/choice_pizza.68',
          '/ip/choice_pizza.69',
          '/ip/choice_pizza.7',
          '/ip/choice_pizza.7.1',
          '/ip/choice_pizza.73',
          '/ip/choice_pizza.74',
          '/ip/choice_pizza.75',
          '/ip/choice_pizza.8',
          '/ip/choice_pizza.83',
          '/ip/choice_pizza.84',
          '/ip/choice_pizza.89',
          '/ip/choice_pizza.9',
          '/ip/choice_pizza.90',
          '/ip/choice_pizza.91',
          '/ip/choice_pizza.92',
          '/pc/choice_pizza.1',
          '/pc/choice_pizza.10',
          '/pc/choice_pizza.11',
          '/pc/choice_pizza.12',
          '/pc/choice_pizza.12.1',
          '/pc/choice_pizza.13',
          '/pc/choice_pizza.14',
          '/pc/choice_pizza.15',
          '/pc/choice_pizza.16',
          '/pc/choice_pizza.16.1',
          '/pc/choice_pizza.17',
          '/pc/choice_pizza.18',
          '/pc/choice_pizza.19',
          '/pc/choice_pizza.2',
          '/pc/choice_pizza.20',
          '/pc/choice_pizza.21',
          '/pc/choice_pizza.22',
          '/pc/choice_pizza.23',
          '/pc/choice_pizza.24',
          '/pc/choice_pizza.25',
          '/pc/choice_pizza.26',
          '/pc/choice_pizza.27',
          '/pc/choice_pizza.28',
          '/pc/choice_pizza.29',
          '/pc/choice_pizza.3',
          '/pc/choice_pizza.30',
          '/pc/choice_pizza.31',
          '/pc/choice_pizza.32',
          '/pc/choice_pizza.33',
          '/pc/choice_pizza.34',
          '/pc/choice_pizza.35',
          '/pc/choice_pizza.37',
          '/pc/choice_pizza.38',
          '/pc/choice_pizza.39',
          '/pc/choice_pizza.4',
          '/pc/choice_pizza.41',
          '/pc/choice_pizza.42',
          '/pc/choice_pizza.5',
          '/pc/choice_pizza.51',
          '/pc/choice_pizza.6',
          '/pc/choice_pizza.7',
          '/pc/choice_pizza.8',
          '/pc/choice_pizza.9',
          '/pc/choice_pizza.94',
          '/pc/choice_pizza.95',
          '/ip/side/W000005148-002',
          '/ip/side/W000005149-002',
          '/pc/side/W000005149-002',
          '/ip/side/W000005147-002',
          '/pc/side/W000005147-002',
          '/ip/side/W000005191-002',
          '/ip/side/W000000744-002',
          '/pc/side/W000000744-002',
          '/ip/side/W000036151-002',
          '/pc/side/W000036151-002',
          '/ip/side/W000000770-002',
          '/pc/side/W000000770-002',
          '/ip/side/W000002228-002',
          '/pc/side/W000002228-002',
          '/ip/side/W000002229-002',
          '/pc/side/W000002229-002',
          '/ip/side/W000002232-002',
          '/pc/side/W000002232-002',
          '/ip/side/W000002233-002',
          '/pc/side/W000002233-002',
          '/ip/side/W000004792-002',
          '/pc/side/W000004792-002',
          '/ip/side/W000002981-002',
          '/pc/side/W000002981-002',
          '/ip/side/W000000742-002',
          '/pc/side/W000000742-002',
          '/ip/side/W00003D005-002',
          '/pc/side/W00003D005-002',
          '/ip/side_menu',
          '/ip/side_menu/',
          '/ip/side_menu/1',
          '/ip/side_menu/2',
          '/ip/side_menu/3',
          '/pc/side_menu/',
          '/pc/side_menu/1',
          '/pc/side_menu/2',
          '/pc/side_menu/3',
          '/ip/side/W000004793-002',
          '/pc/side/W000004793-002',
          '/ip/side/W000004809-002',
          '/pc/side/W000004809-002',
          '/ip/side/W000000743-002',
          '/pc/side/W000000743-002',
          '/ip/side/W000000769-002',
          '/pc/side/W000000769-002',
          '/ip/side/W000002363-002',
          '/pc/side/W000002363-002',
          '/ip/side/W00003D009-002',
          '/pc/side/W00003D009-002',
          '/ip/side/W000001895-002',
          '/pc/side/W000001895-002',
          '/ip/side/W000001181-002',
          '/pc/side/W000001181-002',
          '/ip/side/W000002245-002',
          '/pc/side/W000002245-002',
          '/ip/side/W000004794-002',
          '/pc/side/W000004794-002',
          '/ip/side/W000002221-002',
          '/pc/side/W000002221-002',
          '/ip/side/W000004806-002',
          '/pc/side/W000004806-002',
          '/ip/side/W000001884-002',
          '/pc/side/W000001884-002',
          '/ip/side/W000002295-002',
          '/pc/side/W000002295-002',
          '/ip/side/W000002359-002',
          '/pc/side/W000002359-002',
          '/ip/side/W000002362-002',
          '/ip/set_menu',
          '/ip/set_menu/',
          '/pc/set_menu',
          '/pc/set_menu/',
          '/ip/topics',
          '/pc/topics',
          '/ip/drink_menu',
          '/pc/drink_menu',
          '/ip/pasta_menu/',
          '/ip/pasta_menu/2',
          '/ip/pasta_menu/3',
          '/pc/pasta_menu/',
          '/pc/pasta_menu/3',
          '/ip/user_password_reset',
          '/pc/user_password_reset',
          '/pc/pizza_menu/',
          '/ip/address_select',
          '/pc/address_select'
        ]
        const topics = [
          '/pc/topics'
        ]

        const oldHome = [
          '/home'
        ]

        const faq = [
          '/pc/general/include/cmn_inquiry.html'
        ]
        const member = [
          '/pc/general/include/usr_member_rules.html'
        ]

        const nutrition = [
          '/pc/general/include/prd_allergen.html?link_id=cft_par'
        ]
        const actTrade = [
          '/pc/general/include/cmn_commercial_transactions.html?link_id=cft_cct'
        ]

        const stores = [
          '/ip/shop_detail',
          '/pc/shop_detail'
        ]

        const localizations = [
          '/ip/address_search/ZIP',
          '/ip/shop_search/ZIP',
          '/pc/shop_search/ZIP',
          '/pc/address_search/ZIP'
        ]
        const mappingStores = {
          '2075': 2482,
          '1598': 2481,
          '1981': 2480,
          '2156': 2527,
          '2233': 2530
        }
        for (let i in stores) {
          if (lodash.startsWith(to.fullPath, stores[i])) {
            let path = to.fullPath.split('/')
            if (path.length >= 4) {
              let value = path[3]
              if (mappingStores.hasOwnProperty(value)) {
                value = mappingStores[value]
              }
              return next('/huts/' + value)
            }
          }
        }

        for (let i in topics) {
          if (lodash.startsWith(to.fullPath, topics[i])) {
            return next('/topic')
          }
        }

        for (let i in login) {
          if (lodash.startsWith(to.fullPath, login[i])) {
            return next('/login')
          }
        }

        for (let i in faq) {
          if (lodash.startsWith(to.fullPath, faq[i])) {
            return next('/faq')
          }
        }

        for (let i in member) {
          if (lodash.startsWith(to.fullPath, member[i])) {
            return next('/hutrewards')
          }
        }

        for (let i in nutrition) {
          if (lodash.startsWith(to.fullPath, nutrition[i])) {
            return next('/nutritional-content')
          }
        }

        for (let i in actTrade) {
          if (lodash.startsWith(to.fullPath, actTrade[i])) {
            return next('/indication-based')
          }
        }

        for (let i in localizations) {
          if (lodash.startsWith(to.fullPath, localizations[i])) {
            let path = to.fullPath.split('/')
            if (path.length >= 5 && path[4] !='') {
              return next('/localization/' + path[4])
            }
          }
        }

        for (let i in pageNotFound) {
          if (lodash.startsWith(to.fullPath, pageNotFound[i])) {
            return next('/404')
          }
        }

        for (let i in oldHome) {
          if (lodash.startsWith(to.fullPath, oldHome[i])) {
            return next('/')
          }
        }

        next({path: '/404', query: to.query})
      }
    },
    {
      path: '/cgi-bin/linkshare',
      component: Rakuten
    }
  ]
});

router.beforeResolve((to, from, next) => {
  //vm.$bus.$emit(constants.EVENT_BUS.LOADING, true)
  if (!main.$cookie.get('disposition')) {
    main.$disposition.remove(main)
  }
  if (to.name !== 'home' && to.path && to.path.slice(-1) === '/') {
    let newRouter = to.path.slice(0, -1)
    next(newRouter)
  }
  next()
})

router.afterEach((to, from) => {
  let title = main.$t(to.meta.meta_title)
  let description = main.$t(to.meta.meta_description)

  if (!title) {
    title = main.$t('meta.home.title')
  }
  if (!description) {
    description = main.$t('meta.home.description')
  }

  switch (to.name) {
    case 'category':
      if (to.params.slug == 'hot-deal') {
        title = main.$t('meta.hot_deal.title')
        description = main.$t('meta.hot_deal.description')
      } else if (to.params.slug == 'pizza') {
        title = main.$t('meta.pizza.title')
        description = main.$t('meta.pizza.description')
      } else if (to.params.slug == 'pasta-gratin') {
        title = main.$t('meta.pasta_gratin.title')
        description = main.$t('meta.pasta_gratin.description')
      } else if (to.params.slug == 'side' && to.params.sub == 'potato-chicken') {
        title = main.$t('meta.side_potato_chicken.title')
        description = main.$t('meta.side_potato_chicken.description')
      } else if (to.params.slug == 'drink-dessert') {
        title = main.$t('meta.drink_dessert.title')
        description = main.$t('meta.drink_dessert.description')
      } else if (to.params.slug == 'coupons') {
        title = main.$t('meta.coupons.title')
        description = main.$t('meta.coupons.description')
      }
      break
    case 'home':
      title = main.$t('meta.home.title')
      description = main.$t('meta.home.description')
      break
    case 'faq':
      title = main.$t('meta.faq.title')
      description = main.$t('meta.faq.description')
      break
    case 'indication':
      title = main.$t('meta.indication_based.title')
      description = main.$t('meta.indication_based.description')
      break
    case 'hutrewards':
      title = main.$t('meta.membership.title')
      description = main.$t('meta.membership.description')
      break
    case 'nutritional':
      title = main.$t('meta.nutritional_content.title')
      description = main.$t('meta.nutritional_content.description')
      break
    case 'privacy':
      title = main.$t('meta.privacy.title')
      description = main.$t('meta.privacy.description')
      break
    case 'terms':
      title = main.$t('meta.terms.title')
      description = main.$t('meta.terms.description')
      break
    case 'topic':
      title = main.$t('meta.topic.title')
      description = main.$t('meta.topic.description')
      break
    case 'test-localization':
      if (to.params.zip == '_select') {
        title = main.$t('meta.localization_select')
      } else if (to.params.zip.indexOf('found') >= 0 ) {
        title = main.$t('meta.localization_select')
      }
      break
  }

  let check = false
  DATA_TOPIC.forEach(item => {
    if (to.path === item.url) {
      check = true
    }
  })
  DATA_HUT.forEach(item => {
    if (to.path === item.url) {
      check = true
    }
  })
  if (!check) {
    document.title = main.$t(title)
  }

  if (document.getElementsByTagName('meta')["description"] === undefined) {
    let meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    meta.setAttribute('content', main.$t(description))
    document.head.appendChild(meta);
  } else { // existed
    let descriptionEl = document.getElementsByTagName('meta')["description"]
    descriptionEl.content = description
  }
  let tagH1 = document.getElementById('title-header-tag')
  for (let tag in main.$const.H1_TAG) {
    if (tag === to.path) {
      tagH1.innerHTML = main.$t(main.$const.H1_TAG[tag])
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js